// extracted by mini-css-extract-plugin
export default {"link":"o5Xlx3K9c7","link-active":"iAnMjpMfVb","linkActive":"iAnMjpMfVb","icon":"tJtXKM-Wib"};
    if(module.hot) {
      // 1648554095152
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  